import NavigationList from "@components/navigation-list";
import * as React from 'react';
export default {
  NavigationList,
  React
};